export const dateRangePickerDayClasses = {
  otherMonth: 'date-day--other-month',
  disabled: 'date-day--disabled',
  startDateSelected: 'date-day--start-date-selected',
  endDateSelected: 'date-day--end-date-selected',
  startDateSelectedAndAfterHover: 'date-day--start-date-selected-and-after-hover',
  hasValue: 'date-day--has-value',
  highlighted: 'date-day--highlighted',
  beforeStart: 'date-day--before-start',
  afterStart: 'date-day--after-start',
  labelTop: 'date-day--label-top',
  labelBottom: 'date-day--label-bottom',
}
